
    <!-- firm-detials block -->
    <div class="details-block mt-2">
        <div class="chk-block">
            <div class=" col-md-6 d-flex">
                <strong>Firm Details</strong>
            </div>
            <div class="col-md-6 icon-section">
                <img src="../../../../../assets/images/document hide icon.svg" (click)="togglefirmDetails()">
            </div>
        </div>
        <div *ngIf="!firmDetails">
            <form [formGroup]="formGroup">

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex">
                    <div class="row form-background" style="padding: 10px;">
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label> Comapany Name / LLP / Firm</label>
                                <input type="text" id="companyName" class="companyName" name="companyName"
                                    formControlName="companyName" class="form-control" [placeholder]="'Enter Firm Name'" />
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label>PAN Number</label>
                                <input type="text" id="firmPan" class="firmPan" name="firmPan" type="text"
                                    maxlength="10" formControlName="firmPan" class="form-control" [placeholder]="'Enter Firm PAN Number'"/>
                                <!-- <div *ngIf="formGroup.get('pan').touched && formGroup.get('pan').invalid">
                                    <div *ngIf="formGroup.get('pan').hasError('required')">
                                      PAN is required.
                                    </div>
                                    <div *ngIf="formGroup.get('pan').hasError('invalidPan')">
                                      PAN must be in the format: AAAAA0000A (5 capital letters, 4 digits, 1 capital letter).
                                    </div>
                                  </div> -->
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label>Nature Of Business / Trade</label>
                                <input type="text" id="natureOfBusiness" class="natureOfBusiness"
                                    name="natureOfBusiness" formControlName="natureOfBusiness" [placeholder]="'Enter Firm Business Nature'" class="form-control" />
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label>GST Number</label>
                                <input type="text" id="gstNumber" class="firmgstNumber" name="gstNumber"
                                    formControlName="firmgstNumber" class="form-control" [placeholder]="'Enter Firm GST Number'"/>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div class="form-group">
                                <label>Register Office Address</label>
                                <img src="../../../assets/images/groupHome.svg" class="pl-2 pb-3 homeIcon" (click)="addfirmAddressModal(7)">
                                <input type="text" id="officeAddress" class="officeAddress" name="officeAddress"
                                    formControlName="officeAddress" class="form-control" [placeholder]="'Enter Firm Address'" />
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    </div>
    <p-dialog [(visible)]="showAdressModal"  [modal]="true" [draggable]="false" [resizable]="false"  [blockScroll]=false [style]="{ width: '30rem' }" >
        <p-header>
            {{adressMetaData?.addressLabel}} Address
          </p-header>
          <app-address-detail   [context]="'allotmentContext'" [adressMetaData]="addressToAndFromAddressDetail"  (closeModal)="closeAddAddressModal($event)"></app-address-detail>
        </p-dialog>

    <!-- family members Details block -->
    <div class="details-block mt-2">
        <div class="chk-block">
            <div class="col-md-6 d-flex">
                <strong>Family Members Details</strong>
            </div>
            <div class="col-md-6 icon-section">
                <img src="../../../../../assets/images/addImageIcon.svg"
                    (click)="additionalDetails('familyMemberDetails')" style="width: 14px;">&nbsp;
                <img src="../../../../../assets/images/document hide icon.svg" (click)="togglefamilyDetails()">
            </div>
        </div>
        <div *ngIf="!familyDetails">
            <app-common-table [columnDefs]="familyColumnDefs" [data]="familyRowdata"></app-common-table>
        </div>
    </div>
        <!-- emergency contact details -->
        <div class="details-block mt-2">
            <div class="chk-block">
                <div class="col-md-6 d-flex">
                    <strong>Emergency Contact Details</strong>
                </div>
                <div class="col-md-6 icon-section">
                    <img src="../../../../../assets/images/document hide icon.svg" (click)="toggleEmergencyDetails()">
                </div>
            </div>
            <div class="allotment-form">
                <form [formGroup]="formGroup">
                    <div class="form-background" style="padding: 10px;">
                        <div class="row">
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label>Name  <span class="formMandatoryInput">*</span></label>
                                    <input type="text" id="emergencyName" class="emergencyName" name="emergencyName"
                                        formControlName="emergencyName" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label>Mobile  <span class="formMandatoryInput">*</span></label>
                                    <input type="text" id="emergencyContactNumber" class="emergencyContactNumber"
                                        name="emergencyContactNumber" formControlName="emergencyContactNumber"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label>Relation  <span class="formMandatoryInput">*</span></label>
                                    <input type="text" id="emergencyRelation" class="emergencyRelation"
                                        name="emergencyRelation" formControlName="emergencyRelation" class="form-control" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- nominee details -->
        <div class="details-block mt-2">
            <div class="chk-block">
                <div class="col-md-6 d-flex">
                    <strong>Details Of Nominee</strong>
                </div>
                <div class="col-md-6 icon-section">
                    <img src="../../../../../assets/images/addImageIcon.svg"
                        (click)="additionalDetails('nomineeMemberDetails')" style="width: 14px;">&nbsp;
                    <img src="../../../../../assets/images/document hide icon.svg" (click)="toggleNomineeDetails()">
                </div>
            </div>
            <div *ngIf="!nomineeDetails">
                <app-common-table [columnDefs]="nomineeColumnDefs" [data]="nomineeRowData"></app-common-table>
            </div>
        </div>
        <p-dialog [(visible)]="showDetailedModal" [modal]="true" [draggable]="false" [resizable]="false"
    *ngIf="showDetailedModal" [style]="{ height: '25rem', width:'50rem'}">
    <ng-template pTemplate="header">
        <h6>{{formIdentity}}</h6>
    </ng-template>
    <div>
        <app-common-form [identity]="formIdentity" [commonFormData]="coApplicantDetailsConfig"
            (formSubmit)="onCommonFormSubmit($event)" (hideModal)="hideCommonFormModal()" [suppressContextMenu]="true"></app-common-form>
    </div>
</p-dialog>